import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
var SVG = styled.svg.withConfig({
    componentId: "sc-f20fc496-0"
})([
    "stroke:",
    ";transform:rotateZ( ",
    " );"
], function(props) {
    return props.stroke;
}, function(props) {
    switch(props.direction){
        case "up":
            return "0deg";
        case "right":
            return "90deg";
        case "down":
            return "180deg";
        case "left":
            return "270deg";
        default:
            return "0deg";
    }
});
export var Chevron = function(param) {
    var className = param.className, _param_stroke = param.stroke, stroke = _param_stroke === void 0 ? "black" : _param_stroke, direction = param.direction, width = param.width, height = param.height;
    var actualWidth = width !== null && width !== void 0 ? width : height ? height * 12 / 7 : 12;
    var actualHeight = height !== null && height !== void 0 ? height : width ? width * 7 / 12 : 7;
    return /*#__PURE__*/ _jsx(SVG, {
        width: actualWidth,
        height: actualHeight,
        viewBox: "0 0 12 7",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        className: className,
        direction: direction,
        stroke: stroke,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M1 6.00005L6 0.994751L11 6.00005"
        })
    });
};
